var map = {
	"./DoubtForum.svg": [
		62550,
		2550
	],
	"./E-books.svg": [
		84621,
		4621
	],
	"./Email.svg": [
		60473,
		473
	],
	"./Feedback.svg": [
		89474,
		9474
	],
	"./MyAchievements.svg": [
		94457,
		4457
	],
	"./MyBooks.svg": [
		34905,
		4905
	],
	"./MyDashboard.svg": [
		94515,
		4515
	],
	"./MyLiveClasses.svg": [
		80965,
		965
	],
	"./MyPurchase.svg": [
		38128,
		8128
	],
	"./MyStudyMaterials.svg": [
		42162,
		2162
	],
	"./MyTestSeries.svg": [
		74574,
		4574
	],
	"./MyVideoCourses.svg": [
		39572,
		9572
	],
	"./MyWallet.svg": [
		92022,
		2022
	],
	"./Previousyearpaper.svg": [
		89643,
		9643
	],
	"./Quizz.svg": [
		67930,
		7930
	],
	"./TimeTable.svg": [
		80580,
		580
	],
	"./biometricicon.svg": [
		1676,
		1676
	],
	"./books.svg": [
		21383,
		1383
	],
	"./booksale.svg": [
		23221,
		3221
	],
	"./currentaffairs.svg": [
		20644,
		644
	],
	"./digitalevaluationicon.svg": [
		94144,
		4144
	],
	"./helpdesk.svg": [
		37941,
		7941
	],
	"./lmsicon.svg": [
		66986,
		6986
	],
	"./logout.svg": [
		41693,
		1693
	],
	"./myconnections.svg": [
		48828,
		8828
	],
	"./notes.svg": [
		52754,
		2754
	],
	"./notification.svg": [
		73118,
		3118
	],
	"./onlineassessmenticon.svg": [
		38415,
		8415
	],
	"./onlinevideo.svg": [
		37231,
		7231
	],
	"./practice.svg": [
		79252,
		9252
	],
	"./printedbooks.svg": [
		30555,
		555
	],
	"./pyp.svg": [
		34686,
		4686
	],
	"./quicklinks.svg": [
		98387,
		8387
	],
	"./refer.svg": [
		44355,
		4355
	],
	"./resellbooks.svg": [
		61710,
		1710
	],
	"./rpsicon.svg": [
		32491,
		2491
	],
	"./seperatepanel.svg": [
		85338,
		5338
	],
	"./setting.svg": [
		94877,
		4877
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40619;
module.exports = webpackAsyncContext;